import React, { useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Sidebar from "../../components/Sidebar";
import { FaCalendarAlt, FaDownload } from "react-icons/fa";
import "./AccountantExport.css";

export default function AccountantExport() {
  const [startDate, setStartDate] = useState(new Date("2025-09-24"));
  const [endDate, setEndDate] = useState(new Date("2025-10-24"));
  const [client, setClient] = useState("all");

  const startDateRef = useRef(null);
  const endDateRef = useRef(null);

  const totalExpenses = 0;
  const totalAmount = 0.0;

  const formatDate = (date) => date.toLocaleDateString("en-GB");

  return (
    <div className="app">
      <Sidebar />
      <main className="exports-main">
        <div className="main">
          <header className="exports-header">
            <h1>Exports</h1>
            <p>Export company's data to Excel for reporting</p>
          </header>
          <section className="exports-left">
            <div className="config-card">
              <div style={{ gap: 6 }}>
                <h2 className="card-title">Export Configuration</h2>
                <p className="card-subtitle">
                  Select filters and date range for your export
                </p>
              </div>

              <div className="date-row">
                <div className="date-col">
                  <label className="input-label">From Date</label>
                  <div className="date-wrapper">
                    <DatePicker
                      ref={startDateRef}
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      selectsStart
                      startDate={startDate}
                      endDate={endDate}
                      maxDate={endDate}
                      dateFormat="dd/MM/yyyy"
                      className="input-date"
                      placeholderText="dd/mm/yyyy"
                      onClickOutside={() =>
                        startDateRef.current?.setOpen(false)
                      }
                      onInputClick={() => {}}
                    />
                    <FaCalendarAlt
                      className="date-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        startDateRef.current?.setOpen(true);
                      }}
                    />
                  </div>
                </div>

                <div className="date-col">
                  <label className="input-label">To Date</label>
                  <div className="date-wrapper">
                    <DatePicker
                      ref={endDateRef}
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      selectsEnd
                      startDate={startDate}
                      endDate={endDate}
                      minDate={startDate}
                      dateFormat="dd/MM/yyyy"
                      className="input-date"
                      placeholderText="dd/mm/yyyy"
                      onClickOutside={() => endDateRef.current?.setOpen(false)}
                      onInputClick={() => {}}
                    />
                    <FaCalendarAlt
                      className="date-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        endDateRef.current?.setOpen(true);
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="summary-box">
                <div className="summary-item">
                  <span>Total Expenses</span>
                  <strong>{totalExpenses}</strong>
                </div>
                <div className="summary-item">
                  <span>Total Mileage</span>
                  <strong>{totalExpenses}</strong>
                </div>
                <div className="summary-item">
                  <span>Total Amount</span>
                  <strong>${totalAmount.toFixed(2)}</strong>
                </div>
                <div className="summary-item">
                  <span>Total Profit</span>
                  <strong>{totalExpenses}</strong>
                </div>
                <div className="summary-item">
                  <span>Date Range</span>
                  <strong>
                    {formatDate(startDate)} - {formatDate(endDate)}
                  </strong>
                </div>
              </div>

              <button className="export-btn">
                <FaDownload className="btn-icon" />
                Export to Excel
              </button>
            </div>

            <div className="preview-card">
              <h2 className="card-title">Preview Data</h2>
              <p className="card-subtitle">
                Preview of expenses to be exported
              </p>

              <table className="preview-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Description</th>
                    <th>Category</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan="4" className="no-data">
                      No expenses found for selected filters
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}
